
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileUploadForm } from "./FileUploadForm";
import { FileCategory, NewFileState } from "./types";
import { RefObject } from "react";

interface UploadCardProps {
  newFile: NewFileState;
  setNewFile: (file: NewFileState) => void;
  handleNewFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleAddFile: () => void;
  fileInputRef: RefObject<HTMLInputElement>;
  videoInputRef: RefObject<HTMLInputElement>;
  fileCategories: FileCategory[];
}

export function UploadCard({
  newFile,
  setNewFile,
  handleNewFileChange,
  handleAddFile,
  fileInputRef,
  videoInputRef,
  fileCategories
}: UploadCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Προσθήκη Νέου Αρχείου</CardTitle>
      </CardHeader>
      <CardContent>
        <FileUploadForm
          newFile={newFile}
          onNewFileChange={setNewFile}
          onFileInputChange={handleNewFileChange}
          onAddFile={handleAddFile}
          fileInputRef={fileInputRef}
          videoInputRef={videoInputRef}
          fileCategories={fileCategories}
        />
      </CardContent>
    </Card>
  );
}
